// extracted by mini-css-extract-plugin
export var workingOn = "index-module--workingOn--24C8n";
export var header = "index-module--header--2oqE6";
export var logosContainer = "index-module--logosContainer--1eKSA";
export var logo = "index-module--logo--sKxzq";
export var tailormed = "index-module--tailormed--1CBgF";
export var walkme = "index-module--walkme--2Uyk_";